import explore from './explore';
import genre from './genre';
import metricDetail from './metricDetail';
import common from './common';

const benchmarkComponentMap: any = {
  ...common,
  ...explore,
  ...genre,
  ...metricDetail,
};

export default benchmarkComponentMap;
